'use client';
const assemble = (fn, context, strategy, cache, serializer)=>{
    return strategy.bind(context, fn, cache, serializer);
};

export { assemble };
//# sourceMappingURL=assemble.js.map
